import {
  mainIndex,
  durationDescIndex,
  durationAscIndex,
  signedDateDescIndex,
  downloadedDescIndex
} from "httpRequests/algolia";
import { setResults } from "../state/results";
import { setSearching } from "../state/searching";
import { setPagination } from "../state/pagination";
import moment from "moment";
import { sendClearAllFilterAnalytics, sendFiltersAnalytics } from "helpers/searchPageAnalytics";
import request from "superagent";

export default () => async (dispatch, getState) => {
  const { router } = getState();
  const { pages, auth } = getState();
  const { searchTerms, params, pagination, searching } = pages.search;

  const tags = [...params.footageType, ...params.tones];

  if (searching) return;

  const { query } = router.location;
  const threshold = query?.threshold || "";

  let clientIndex = mainIndex;

  const userToken = auth.loggedIn ? auth.userProfile?.profile?.id : "guest";
  const filter = {
    userToken,
    hitsPerPage: pagination.sizePerPage,
    page: pagination.currentPage - 1,
    facets: ["category"],
    facetFilters: [],
    threshold: threshold
  };

  const categoriesIncluded = params?.categories
    ?.filter((item) => item.checked === true)
    ?.map((item) => `category:${item.name}`);

  const categoriesExclude = params?.categories
    ?.filter((item) => item.checked === "indeterminate")
    ?.map((item) => `NOT category:'${item.name}'`);

  const popularityIncluded = (params && params.popularity ? params.popularity : [])
    ?.filter((item) => item.checked === true)
    ?.map((item) => `acquisitionPurpose:${item.name}`);

  const popularityExclude = (params && params.popularity ? params.popularity : [])
    ?.filter((item) => item.checked === "indeterminate")
    ?.map((item) => `NOT acquisitionPurpose:'${item.name}'`);

  const activeSort = params.smartSort.filter((item) => item.checked === true)?.map((item) => item);

  const isVertical = params.orientation
    ?.filter((item) => item.checked === true)
    ?.map((item) => item);

  const tagsIncluded = tags
    ?.filter((item) => item.checked === true)
    ?.map((item) => `tags:${item.name}`);

  const tagsExcluded = tags
    ?.filter((item) => item.checked === "indeterminate")
    ?.map((item) => `NOT tags:${item.name}`);

  const clearanceIncluded = params.clearance
    ?.filter((item) => item.checked === true)
    ?.map((item) => `clearanceStatus:${item.value}`);

  const countriesIncluded = params.countries
    ?.filter((item) => item.checked === true)
    ?.map((item) => `country:${item.name}`);

  if (countriesIncluded?.length > 0) {
    filter.facetFilters = [countriesIncluded];
  }

  if (categoriesIncluded?.length > 0) {
    filter.facetFilters = [categoriesIncluded];
  }

  if (categoriesExclude?.length > 0) {
    filter.filters = categoriesExclude.join(" AND ");
  }

  if (popularityIncluded?.length > 0) {
    filter.facetFilters = [...filter?.facetFilters, popularityIncluded];
  }

  if (popularityExclude?.length > 0) {
    filter.filters = popularityExclude.join(" AND ");
  }

  if (clearanceIncluded?.length > 0) {
    filter.facetFilters = [...filter?.facetFilters, clearanceIncluded];
  }

  if (tagsIncluded?.length > 0) {
    filter.facetFilters = [...filter?.facetFilters, tagsIncluded];
  }

  if (tagsExcluded?.length > 0) {
    filter.filters = tagsExcluded.join(" AND ");
  }

  if (isVertical?.length > 0 && isVertical[0].name === "Vertical") {
    filter.facetFilters = [...filter?.facetFilters, ["isVertical:true"]];
  } else if (isVertical?.length > 0 && isVertical[0].name === "Horizontal") {
    filter.facetFilters = [...filter?.facetFilters, ["isVertical:false"]];
  }

  if (params.resolution) {
    if (params.resolution[1].checked) {
      filter.facetFilters = [...filter?.facetFilters, ["isHD:true"]];
    }
  }

  if (params.duration[0] !== 0 || params.duration[1] !== 600) {
    const durationFilter = `duration: ${params.duration[0]} TO ${params.duration[1]}`;
    if (filter.filters) {
      filter.filters = filter.filters + ` AND ${durationFilter}`;
    } else {
      filter.filters = durationFilter;
    }
  }

  if (params.uploaded && params.uploaded !== null) {
    if (params.uploaded[0].checked) {
      if (params.dates && (params.dates.postedFrom !== null || params.dates.postedTo !== null)) {
        let datePostedFilter;

        let datePostedFrom = params.dates.postedFrom
          ? moment(params.dates.postedFrom).format("x")
          : moment(new Date("1990")).format("x");
        let datePostedTo = params.dates.postedTo
          ? moment(params.dates.postedTo).format("x")
          : moment().format("x");

        const today = moment().endOf("day");
        const isFutureFromDate = moment(params.dates.postedFrom).isAfter(today);
        const isFutureToDate = moment(params.dates.postedTo).isAfter(today);
        const isFromDateAfterToDate = moment(params.dates.postedFrom).isAfter(
          params.dates.postedTo
        );

        if (
          !isFutureFromDate &&
          !isFutureToDate &&
          !isFromDateAfterToDate &&
          params.dates.postedFrom._isValid &&
          params.dates.postedTo._isValid
        ) {
          datePostedFilter = `originalPublishingDateUnixTime: ${datePostedFrom} TO ${datePostedTo}`;

          if (filter.filters) {
            filter.filters = filter.filters + ` AND ${datePostedFilter}`;
          } else {
            filter.filters = datePostedFilter;
          }
        }
      }
    } else {
      let datePostedFilter;
      let datePostedFrom;
      const datePostedTo = moment().format("x");

      if (params.uploaded[1].checked) {
        datePostedFrom = moment().subtract(72, "hours").format("x");
      }
      if (params.uploaded[2].checked) {
        datePostedFrom = moment().subtract(7, "days").format("x");
      }
      if (params.uploaded[3].checked) {
        datePostedFrom = moment().subtract(30, "days").format("x");
      }
      if (params.uploaded[4].checked) {
        datePostedFrom = moment().subtract(12, "months").format("x");
      }

      if (datePostedFrom && datePostedFrom != null) {
        datePostedFilter = `originalPublishingDateUnixTime: ${datePostedFrom} TO ${datePostedTo}`;
        if (filter.filters) {
          filter.filters = filter.filters + ` AND ${datePostedFilter}`;
        } else {
          filter.filters = datePostedFilter;
        }
      }
    }
  }

  if (params.dates && (params.dates.acquiredFrom !== null || params.dates.acquiredTo !== null)) {
    let dateAddedFilter;

    const dateAddedFrom = params.dates.acquiredFrom
      ? moment(params.dates.acquiredFrom).format("x")
      : moment(new Date("1990")).format("x");
    const dateAddedTo = params.dates.acquiredTo
      ? moment(params.dates.acquiredTo).format("x")
      : moment().format("x");

    dateAddedFilter = `signedDateUnixTime: ${dateAddedFrom} TO ${dateAddedTo}`;

    if (filter.filters) {
      filter.filters = filter.filters + ` AND ${dateAddedFilter}`;
    } else {
      filter.filters = dateAddedFilter;
    }
  }

  if (params?.similarClip !== null && params?.similarClip?.jmId !== undefined) {
    filter.similarClipsOnly = true;
    filter.jmId = params?.similarClip?.jmId;
  }

  if (activeSort.length > 0) {
    const activeSortValue = activeSort[0].name;

    if (activeSortValue === "Most Recent") {
      clientIndex = signedDateDescIndex;
    } else if (activeSortValue === "Most Downloaded") {
      clientIndex = downloadedDescIndex;
    } else if (activeSortValue === "Duration: Short to Long") {
      clientIndex = durationAscIndex;
    } else if (activeSortValue === "Duration: Long to Short") {
      clientIndex = durationDescIndex;
    } else {
      clientIndex = mainIndex;
    }
  } else {
    clientIndex = mainIndex;
  }

  try {
    if (router.location.pathname.includes("/search")) {
      dispatch(setSearching(true));

      const response = await clientIndex.search(searchTerms, filter);
      const currentPage = pagination.currentPage;
      dispatch(setResults(response.hits));

      const paginationPayload = {
        totalPages: response.nbPages > 1 ? response.nbPages : 1,
        sizePerPage: response.hitsPerPage,
        totalResults: response.nbHits,
        totalFilterResult: response.nbSortedHits,
        query: response.query
      };

      dispatch(setPagination(paginationPayload));

      dispatch(setSearching(false));
      sendFiltersAnalytics({ ...paginationPayload, currentPage }, params);
      sendClearAllFilterAnalytics(paginationPayload, params, dispatch);
    }
  } catch (error) {
    // dispatch(handleException(error));
  }
};
